import {useFormContext} from 'react-hook-form'
import {Alert, Col} from 'antd'
import dayjs from 'dayjs'
import {CampaignPacing, CampaignType} from '../../../../__generated__/graphql'

const EVEN_PACING_EXTENSION_WARNING =
  "Extending your end date while using 'Even pacing' may temporarily pause delivery. To avoid this, we recommend deactivating 'Even pacing' and setting a 'Daily budget limit'."

const hasDailyBudgetLimit = (value: unknown) =>
  value !== null && value !== undefined && value !== '' && Number(value) > 0

const isEvenPacingExtensionResolved = (
  values: {pacing?: unknown; dailyBudgetLimit?: unknown} | undefined,
) => values?.pacing !== CampaignPacing.Even && hasDailyBudgetLimit(values?.dailyBudgetLimit)

const isEndDateExtended = (currentEndDate: unknown, originalEndDate: unknown) =>
  !!currentEndDate &&
  !!originalEndDate &&
  dayjs(currentEndDate as any).isAfter(dayjs(originalEndDate as any))

export const isUnsafeEvenPacingExtension = (
  values: {pacing?: unknown; campaignPeriod?: {endDate?: unknown}; dailyBudgetLimit?: unknown} | undefined,
  everActivated: boolean | null | undefined,
  originalEndDate: unknown,
) =>
  !!everActivated &&
  isEndDateExtended(values?.campaignPeriod?.endDate, originalEndDate) &&
  !isEvenPacingExtensionResolved(values)

// Advisory only — this must never gate Save (CON-596).
const EvenPacingExtensionWarning = ({
  isNewEntity,
  hidePacingField,
  everActivated,
}: {
  isNewEntity?: boolean
  hidePacingField?: boolean
  everActivated?: boolean
}) => {
  const {watch, formState} = useFormContext()

  const pacing = watch('pacing')
  const campaignPeriod = watch('campaignPeriod')
  const dailyBudgetLimit = watch('dailyBudgetLimit')
  const campaignType = watch('type')
  const originalEndDate: unknown = (formState.defaultValues as any)?.campaignPeriod?.endDate

  const applies =
    !isNewEntity && !hidePacingField && campaignType !== CampaignType.Filler

  if (
    !applies ||
    !isUnsafeEvenPacingExtension({pacing, campaignPeriod, dailyBudgetLimit}, everActivated, originalEndDate)
  ) {
    return null
  }

  return (
    <Col span={24}>
      <Alert
        type='warning'
        showIcon
        className='mb-4 max-w-2xl'
        message={EVEN_PACING_EXTENSION_WARNING}
      />
    </Col>
  )
}

export default EvenPacingExtensionWarning
